import styled from 'styled-components';
import { ReactComponent as RawNoteSVG } from '../../../../assets/icons/icon_note.svg';

export const IconNote = styled(RawNoteSVG)``;
